'use strict';

/**
 * React-only vendor module
 * Contains CSS and JS dependencies for React components only.
 * Excludes all AngularJS-specific libraries.
 */

// CSS libraries
import 'normalize.css/normalize.css';
import 'bootstrap/dist/css/bootstrap.css';

// Date/time handling is no longer exposed on `window`: modules import
// '@techsee/techsee-date' directly, which also drops the bundled
// moment-timezone dataset this used to pull in (HY-639).

// TechSee common utilities
// import 'expose-loader?exposes=LoginEncoder!@techsee/techsee-common/lib/login-info-encoder';
// import 'expose-loader?exposes=TsUtils!@techsee/techsee-common/lib/utils';

// Direct imports - core libraries
import 'lodash';
import 'react';
import 'react-dom';
import 'js/fabric.js';

// Type declarations for window-exposed libraries
declare global {
    interface Window {
        LoginEncoder: any;
        TsUtils: any;
    }
}

export {};
